import { Link } from '@tanstack/react-router';
import Icon from '../../ui/Icon';
import { Note } from '../../../types/api';
import { formatRelativeTime } from '../../../utils/dateUtils';

interface BookmarkNotesListProps {
  notes: Note[];
  bookmarkId: string;
}

function BookmarkNotesList({ notes, bookmarkId }: BookmarkNotesListProps) {
  return (
    <div className="bookmark-notes-list">
      {notes.map((note) => {
        const highlightId = note.highlight_id ?? note.id;
        return (
          <Link
            key={note.id}
            to="/read/$bookmarkId/$highlightId"
            params={{
              bookmarkId: note.bookmark_id || bookmarkId,
              highlightId,
            }}
            className="bookmark-note-item"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="bookmark-note-text">{note.text}</div>
            {note.note && (
              <div className="bookmark-note-comment">
                <Icon name="note" className="flex-shrink-0" />
                <div className="bookmark-note-comment-text">{note.note}</div>
              </div>
            )}
            <span className="bookmark-note-date">{formatRelativeTime(note.time)}</span>
          </Link>
        );
      })}
    </div>
  );
}

export default BookmarkNotesList;
